export const accountTranslation = {
    en: {
      "home": "Home",
      "Settings": "Settings",
      "Account": "Account",
      "Username (Email)": "Username (Email)",
      "Enter your email": "Enter your email",
      "Password": "Password",
      "Enter your password": "Enter your password",
      "Confirm Password": "Confirm Password",
      "Confirm your password": "Confirm your password",
      "Update": "Update",
      "Passwords do not match": "Passwords do not match",
      "Account updated successfully": "Account updated successfully",
      "Failed to update account": "Failed to update account",
      "OTP Login Enabled":"OTP Login Enabled",
      "Phone Number": "Phone Number",
      "Account updated successfully. For security, you will be logged out. Please log in again with your new credentials.": "Account updated successfully. For security, you will be logged out. Please log in again with your new credentials."
    },
    ar: {
      "home": "الصفحة الرئيسية",
      "Settings": "الإعدادات",
      "Account": "الحساب",
      "Username (Email)": "اسم المستخدم (البريد الإلكتروني)",
      "Enter your email": "أدخل بريدك الإلكتروني",
      "Password": "كلمة المرور",
      "Enter your password": "أدخل كلمة المرور الخاصة بك",
      "Confirm Password": "تأكيد كلمة المرور",
      "Confirm your password": "أكد كلمة المرور الخاصة بك",
      "Update": "تحديث",
      "Passwords do not match": "كلمات المرور غير متطابقة",
      "Account updated successfully": "تم تحديث الحساب بنجاح",
      "Failed to update account": "فشل في تحديث الحساب",
      "OTP Login Enabled":"تم تفعيل تسجيل الدخول عبر OTP",
      "Phone Number": "رقم الهاتف",
      "Account updated successfully. For security, you will be logged out. Please log in again with your new credentials.": "تم تحديث الحساب بنجاح. لأسباب أمنية، سيتم تسجيل خروجك. يرجى تسجيل الدخول مرة أخرى باستخدام بيانات الاعتماد الجديدة الخاصة بك."
    },
  };
  